/**
 * Demo mode utilities and configuration
 * Contains all demo-specific data and logic
 */

// Check if we're in demo mode
export const isDemoMode = () => {
  return typeof window !== 'undefined' && localStorage.getItem('isDemo') === 'true';
};

// Dummy data for demo mode
export const dummyCompany = {
  nombre: 'Demo Company S.L.',
  correo_electronico: 'demo@company.com',
  nif: 'B12345678',
  eori: 'ES123456789012',
  direccion: 'Calle Demo 123, Planta 4',
  localidad: 'Madrid',
  codigo_postal: '28001',
  pais: 'ES',
  aduana_habitual: 'ES0001'
};

export const dummyAgent = {
  id: 1,
  nombre: 'Demo Customs Agent',
  nif: 'A98765432',
  eori: 'ES987654321098',
  direccion: 'Avenida Agente 456',
  localidad: 'Barcelona',
  codigo_postal: '08001',
  pais: 'ES',
  identificacion_fiscal: 'A98765432',
  correo_electronico: 'agent@demo.com',
  contacto_telefono: '+34 912 345 678'
};

export const dummySender = {
  id: 1,
  nombre: 'Demo Sender Company',
  nif: 'B11111111',
  eori: 'ES111111111111',
  direccion: 'Sender Street 789',
  localidad: 'Valencia',
  codigo_postal: '46001',
  pais: 'ES',
  identificacion_fiscal: 'B11111111',
  correo_electronico: 'sender@demo.com',
  contacto_telefono: '+34 923 456 789'
};

export const dummyReceiver = {
  id: 1,
  nombre: 'Demo Receiver Company',
  nif: 'B22222222',
  eori: 'ES222222222222',
  direccion: 'Receiver Avenue 321',
  localidad: 'Sevilla',
  codigo_postal: '41001',
  pais: 'ES',
  identificacion_fiscal: 'B22222222',
  correo_electronico: 'receiver@demo.com',
  contacto_telefono: '+34 934 567 890'
};

/**
 * Get final agents array with demo fallback
 */
export const getFinalAgents = (agents, isDemo) => {
  if (isDemo && (!agents || agents.length === 0)) {
    return [dummyAgent];
  }
  return agents || [];
};

/**
 * Get final senders array with demo fallback
 */
export const getFinalSenders = (senders, isDemo) => {
  if (isDemo && (!senders || senders.length === 0)) {
    return [dummySender];
  }
  return senders || [];
};

/**
 * Get final receivers array with demo fallback
 */
export const getFinalReceivers = (receivers, isDemo) => {
  if (isDemo && (!receivers || receivers.length === 0)) {
    return [dummyReceiver];
  }
  return receivers || [];
};

/**
 * Get scroll container ID based on demo mode
 */
export const getScrollContainerId = (isDemo) => {
  return isDemo ? 'demo-container' : 'analysis-report';
};

